// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__nJimz","row":"Node_row__1WS0P","label":"Node_label__1b4b3","footer":"Node_footer__X2qOG"};